import { Map } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
export const actions = {
    REQUEST: createAction('GLOBAL/TAGS_ENTITLEMENTS/REQUEST'),
    SUCCESS: createAction('GLOBAL/TAGS_ENTITLEMENTS/SUCCESS'),
    ERROR: createAction('GLOBAL/TAGS_ENTITLEMENTS/ERROR'),
};
export const initialState = Map({
    isProcessing: false,
    data: null,
    error: null,
});
const reducer = handleActions({
    [actions.REQUEST]: (state = initialState) => state.set('isProcessing', true),
    [actions.SUCCESS]: (state = initialState, action) => state.set('isProcessing', false).set('data', action.payload),
    [actions.ERROR]: (state = initialState) => state.set('error', true).set('isProcessing', false),
}, initialState);
export default reducer;
